import { render, staticRenderFns } from "./ComponentSetIcon.vue?vue&type=template&id=9f9f5b04&"
import script from "./ComponentSetIcon.vue?vue&type=script&lang=js&"
export * from "./ComponentSetIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports